export const RECEIVE_LINK_ME = "RECEIVE_LINK_ME";

export const CHANGE_SORT_OPTION = "CHANGE_SORT_OPTION";

export const UPDATE_LINK_ME = "UPDATE_LINK_ME";
